import AlertInterface from "@app/Interface/AlertInterface";

interface AlertPostInterface {
    id: number;
    postTitle: string;
    alertDetails: string;
    alertType: string;
    recurrence: string;
    alertStartDate: string;
    alertEndDate: string;
}

export default class AlertModel implements AlertInterface {
    public id: number;
    public title: string;
    public details: string;
    public type: string;
    public recurrence: string;
    public start: Date;
    public end: Date;

    constructor(alert?: AlertPostInterface) {
        this.id = alert?.id ?? 0;
        this.title = alert?.postTitle ?? '';
        this.details = alert?.alertDetails ?? '';
        this.type = alert?.alertType ?? 'in_page';
        this.recurrence = alert?.recurrence ?? 'continuous';
        this.start = alert?.alertStartDate ? new Date(alert.alertStartDate) : new Date();
        this.end = alert?.alertEndDate ? new Date(alert.alertEndDate) : new Date();
    }

}
